import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { ITableFields } from "../../../../../contentful/__generated__/types";

import "./style.scss";

type Props = {
  fields: ITableFields;
};

const generateAnchorId = (name?: string): string => {
  return (
    name
      ?.toLowerCase()
      .replace(/^q: /, "")
      .replace(/[()]/g, "")
      .replace(/[/-]/g, " ")
      .replace(/\s+/g, "-")
      .replace(/[^\w-]/g, "") || ""
  );
};

const Table: React.FC<Props> = ({ fields }) => {
  const location = useLocation();
  const elementRef = useRef<HTMLHeadingElement>(null);
  const anchorId = generateAnchorId(fields.name);

  useEffect(() => {
    if (location.hash === `#${anchorId}` && elementRef.current) {
      elementRef.current.scrollIntoView();
    }
  }, [location.hash, anchorId]);

  return (
    <div
      className={`table__wrapper ${
        fields.equalWidthColumns ? "equalWidthColumns" : ""
      }`}
    >
      {fields.showNameDescription && (
        <>
          <h4 id={anchorId} className="table__name" ref={elementRef}>
            {fields.name}
          </h4>
          {fields.description && (
            <p className="table__description">{fields.description}</p>
          )}
        </>
      )}
      {documentToReactComponents(fields.table)}
    </div>
  );
};

export default Table;
